/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  loadingList: false,
  loadedList: false,
  loading: false,
  loaded: false,
  isLoaded: false,
  isLoading: false,
  currentConnector: {},
  successResponse: null,
  togglingStatus: false,
  toggleStatusResponse: null,
  toggleStatusError: null,
  entities: {},
  validating: false,
  validated: true,
  validateResponse: null,
  validateError: null,
  filter: null,
  currentConnectorDel: {},
  validateNameResponse: null,
  validateNameErrorResponse: null,
  connectorConfigStats: {},
  connectorChangeLogLoading: false,
  connectorChangeLogLoaded: false,
  connectorChangeLog: [],
  bigqueryMappingLoading: false,
  bigqueryMappingLoaded: false,
  bigqueryMapping: [],
  bigqueryMappingError: null,
  bigqueryUpdateSuccessMsg: null,
  bigqueryUpdateFailedMsg: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CONNECTORS: {
      return {
        ...state,
        loadingList: true,
        loadedList: false,
      };
    }
    case types.FETCH_CONNECTORS_SUCCESS: {
      return {
        ...state,
        loadingList: false,
        loadedList: true,
        ...action.payload,
      };
    }
    case types.FETCH_CONNECTORS_FAILED: {
      return {
        ...state,
        loadingList: false,
        loadedList: true,
        error: action.payload,
      };
    }
    case types.LOAD_MORE_CONNECTORS_SUCCESS:
      return {
        ...state,
        list: [...state.list, ...action.payload],
        isLoading: false,
      };
    case types.LOAD_MORE_CONNECTORS_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case types.FETCH_A_CONNECTOR: {
      return {
        ...state,
        loading: true,
        loaded: false,
        currentConnector: {},
        error: null,
      };
    }
    case types.FETCH_A_CONNECTOR_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        currentConnector: action.payload,
      };
    }
    case types.FETCH_A_CONNECTOR_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.CHANGE_CONNECTOR_STATUS: {
      return {
        ...state,
        // togglingStatus: true,
        // toggleStatusResponse: null,
        // toggleStatusError: null
        currentConnector: {
          ...state.currentConnector,
          configStatus: action.payload.configStatus,
        },
      };
    }
    case types.CHANGE_CONNECTOR_STATUS_SUCCESS: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.CHANGE_CONNECTOR_STATUS_FAILED: {
      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.REMOVE_CONNECTOR: {
      return {
        ...state,
        currentConnector: {},
        successResponse: null,
        error: null,
      };
    }
    case types.CREATE_CONNECTOR: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }
    case types.CREATE_CONNECTOR_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        successResponse: action.payload,
      };
    }
    case types.CREATE_CONNECTOR_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.UPDATE_CONNECTOR: {
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    }
    case types.UPDATE_CONNECTOR_SUCCESS: {
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.UPDATE_CONNECTOR_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_CONNECTOR_OF_DATAPIPE_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [action.payload.mappingId]: action.payload,
        },
      };
    }
    case types.FETCH_CONNECTOR_OF_DATAPIPE_FAIL: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.VALIDATE_CONNECTOR: {
      return {
        ...state,
        validating: true,
        validated: false,
        validateError: null,
        validateResponse: null,
      };
    }
    case types.VALIDATE_CONNECTOR_SUCCESS: {
      return {
        ...state,
        validating: false,
        validated: true,
        validateResponse: action.payload,
        validateError: null,
      };
    }
    case types.VALIDATE_CONNECTOR_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        validating: false,
        validated: true,
        validateError: action.payload,
        validateResponse: null,
      };
    }
    case types.REMOVE_VALIDATION: {
      return {
        ...state,
        validating: false,
        validated: true,
        validateResponse: null,
        validateError: null,
      };
    }
    case types.SET_CONNECTOR_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case types.REMOVE_CONNECTOR_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: null,
      };
    }
    case types.DELETE_CONNECTOR: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    case types.DELETE_CONNECTOR_SUCCESS: {
      return {
        ...state,
        loaded: false,
        loading: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_CONNECTOR_FAILED: {
      return {
        ...state,
        loaded: false,
        loading: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_CONNECTOR_DEL: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_CONNECTOR_DEL_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        currentConnectorDel: action.payload,
      };
    }
    case types.FETCH_A_CONNECTOR_DEL_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.REMOVE_DEL_CONNECTOR: {
      return {
        ...state,
        currentConnectorDel: {},
        successResponse: null,
      };
    }
    case types.CLEAR_CONNECTOR: {
      return {
        ...state,
        list: [],
        error: null,
        loading: false,
        loaded: false,
        isLoading: false,
        successResponse: null,
      };
    }

    case types.UPDATE_LINK_CONNECTOR: {
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.UPDATE_LINK_CONNECTOR_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        isLoaded: true,
        successResponse: action.payload,
      };
    }
    case types.UPDATE_LINK_CONNECTOR_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.UPDATE_CONNECTOR_LIST: {
      return {
        ...state,
        list: state.list.map((value) =>
          value.id === action.payload.connector.id
            ? {
                ...value,
                projectId: action.payload.connector.projectId,
                projectName:
                  action.payload.connector.projectId !== null
                    ? action.payload.projectName
                    : null,
              }
            : value,
        ),
      };
    }
    case types.VALIDATE_CONNECTOR_NAME: {
      return {
        ...state,
        validateNameResponse: null,
      };
    }
    case types.VALIDATE_CONNECTOR_NAME_SUCCESS: {
      return {
        ...state,
        validateNameResponse: action.payload,
        validateNameErrorResponse: null,
      };
    }
    case types.VALIDATE_CONNECTOR_NAME_FAILED: {
      return {
        ...state,
        validateNameResponse: null,
        validateNameErrorResponse: action.payload,
      };
    }
    case types.REMOVE_VALIDATION_NAME: {
      return {
        ...state,
        validateNameResponse: null,
        validateNameErrorResponse: null,
      };
    }
    case types.FETCH_A_CONNECTOR_CONFIG_STATS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_CONNECTOR_CONFIG_STATS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        connectorConfigStats: action.payload,
      };
    }
    case types.FETCH_A_CONNECTOR_CONFIG_STATS_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_CONNECTOR_CONFIG_STATS: {
      return {
        ...state,
        connectorConfigStats: {},
        isLoading: false,
        isLoaded: false,
        error: null,
      };
    }
    case types.CLEAR_CONNECTOR_LIST: {
      return {
        ...state,
        list: [],
      };
    }
    case types.FETCH_CONNECTOR_LOGS: {
      return {
        ...state,
        connectorChangeLogLoading: true,
        connectorChangeLogLoaded: false,
        list: [],
      };
    }
    case types.FETCH_CONNECTOR_LOGS_SUCCESS: {
      return {
        ...state,
        connectorChangeLogLoading: false,
        connectorChangeLogLoaded: true,
        connectorChangeLog: action.payload,
      };
    }
    case types.FETCH_CONNECTOR_LOGS_FAILED: {
      return {
        ...state,
        connectorChangeLogLoading: false,
        connectorChangeLogLoaded: true,
        connectorChangeLog: [],
      };
    }
    case types.FETCH_BIGQUERY_MAPPING: {
      return {
        ...state,
        bigqueryMappingLoading: true,
        bigqueryMappingLoaded: false,
        bigqueryMappingError: null,
        bigqueryMapping: [],
      };
    }
    case types.FETCH_BIGQUERY_MAPPING_SUCCESS: {
      return {
        ...state,
        bigqueryMappingLoading: false,
        bigqueryMappingLoaded: true,
        bigqueryMapping: action.payload,
      };
    }
    case types.FETCH_BIGQUERY_MAPPING_FAILED: {
      return {
        ...state,
        bigqueryMappingLoading: false,
        bigqueryMappingLoaded: true,
        bigqueryMapping: [],
        bigqueryMappingError: action.payload,
      };
    }
    case types.BIGQUERY_UPDATE: {
      return {
        ...state,
        bigqueryUpdateSuccessMsg: null,
        bigqueryUpdateFailedMsg: null,
      };
    }
    case types.BIGQUERY_UPDATE_SUCCESS: {
      return {
        ...state,
        bigqueryUpdateSuccessMsg: action?.payload,
        bigqueryUpdateFailedMsg: null,
      };
    }
    case types.BIGQUERY_UPDATE_FAILED: {
      return {
        ...state,
        bigqueryUpdateSuccessMsg: null,
        bigqueryUpdateFailedMsg: action?.payload,
      };
    }
    case types.RESET_BIGQUERY_UPDATE_MSGS: {
      return {
        ...state,
        bigqueryUpdateSuccessMsg: null,
        bigqueryUpdateFailedMsg: null,
      };
    }
    case types.CLEAR_CONNECTOR_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}
